<template>
  <v-app>
    <!-- Navbar -->
    <v-container class="tw-p-0 default_width"> 
      <!-- <div class="transition is-active"></div> Fade -->
      <div id="nav" class="navbar tw-z-50 tw-flex tw-w-full tw-flex-col"> 
        <div class="tw-h-8 tw-pt-2 tw-px-4 tw-w-full tw-pb-8 tw-transform tw-duration-500" :class="{'bg_nav': isScrolled, 'tw-bg-transparent' : !isScrolled}">
          <div class="tw-flex tw-items-center tw-text-xs">
            <div class="tw-flex tw-w-full tw-items-center md:tw-justify-end tw-justify-between">
              <div class="tw-flex tw-items-center tw-w-50" v-if="loaded">
                <span class="tw-mr-4 tw-font-sans md:tw-block tw-hidden" :class="{'color_gray': isScrolled}">{{ selectedLanguage == 'US' ? en.title_social_media : pt.title_social_media}}</span>
                <a :href="artist.options.facebookUrl" target="_blank" class="tw-mx-1 tw-bg-transparent" v-if="artist.options.facebookUrl && artist.options.facebookUrl !== '#'">
                  <i id="i_facebook" aria-hidden="true" :class="{'color_gray': isScrolled}" class="v-icon notranslate tw-text-lg fab fa-facebook tw-p-1 hover:tw-bg-blue-700 hover:tw-text-white tw-rounded theme--dark"></i>
                </a>
                <a :href="artist.options.instagramUrl" target="_blank" class="tw-mx-1 tw-bg-transparent" v-if="artist.options.instagramUrl && artist.options.instagramUrl !== '#'">
                  <i id="i_instagram" aria-hidden="true" :class="{'color_gray': isScrolled}" class="v-icon notranslate tw-text-lg fab fa-instagram tw-p-1 hover:tw-bg-red-500 hover:tw-text-white tw-rounded theme--dark"></i>
                </a>
                <a :href="artist.options.twitterUrl" target="_blank" class="tw-mx-1 tw-bg-transparent" v-if="artist.options.twitterUrl && artist.options.twitterUrl !== '#'">
                  <i id="i_twitter" aria-hidden="true" :class="{'color_gray': isScrolled}" class="v-icon notranslate tw-text-lg fab fa-twitter tw-p-1 hover:tw-bg-blue-500 hover:tw-text-white tw-rounded theme--dark"></i>
                </a>
                <a :href="artist.options.spotifyUrl" target="_blank" class="tw-mx-1 tw-bg-transparent" v-if="artist.options.spotifyUrl && artist.options.spotifyUrl !== '#'">
                  <i id="i_spotify" aria-hidden="true" :class="{'color_gray': isScrolled}" class="v-icon notranslate tw-text-lg fab fa-spotify tw-p-1 hover:tw-bg-green-600 hover:tw-text-white tw-rounded theme--dark"></i>
                </a>
                <a :href="artist.options.youtubeUrl" target="_blank" class="tw-mx-1 tw-bg-transparent" v-if="artist.options.youtubeUrl && artist.options.youtubeUrl !== '#'">
                  <i id="i_youtube" aria-hidden="true" :class="{'color_gray': isScrolled}" class="v-icon notranslate tw-text-lg fab fa-youtube tw-p-1 hover:tw-bg-red-700 hover:tw-text-white tw-rounded theme--dark"></i>
                </a>
              </div>
              <div class="tw-full tw-ml-4">
                <div class="tw-rounded dropdown-content">
                    <div class="tw-w-full tw-flex">
                        <a @click="switchLanguage('BR')" class="tw-text-xs tw-leading-none tw-px-1 tw-py-1 tw-rounded tw-flex tw-justify-center tw-items-center" :class="{'color_gray': isScrolled, 'tw-text-white' : !isScrolled}">
                            <img src="/imgs/flags/pt_br.svg" class="tw-w-5 tw-mr-2" /> BR
                        </a>
                        <a @click="switchLanguage('US')" class="tw-text-xs tw-leading-none tw-px-1 tw-py-1 tw-rounded tw-flex tw-justify-center tw-items-center" :class="{'color_gray': isScrolled, 'tw-text-white' : !isScrolled}">
                            <img src="/imgs/flags/en.svg" class="tw-w-5 tw-mr-2" /> US
                        </a>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="tw-transform tw-flex tw-items-center tw-duration-500" :class="{'bg_sub_nav color_gray': isScrolled, 'tw-bg-transparent': !isScrolled}" id="subnav">
          <nav class="tw-container tw-px-6 tw-py-4 tw-mx-auto md:tw-flex md:tw-justify-between md:tw-items-center">
            <div class="tw-flex tw-items-center tw-justify-between">
              <inertia-link class="tw-mr-4" :href="'/artist/'+artist.artista_url+'/'">
                <v-img max-height="46px" max-width="150px" v-if="loaded == true && pageOptions.logo" :src="pageOptions.logo"/>
                <v-img max-height="46px" max-width="46px" v-if="loaded == true && (artist.post_image && !pageOptions.logo)" :src="artist.post_image" class="tw-rounded-full tw-object-cover" />
                <v-avatar v-else-if="loaded == true && (!artist.post_image && !pageOptions.logo)"><img :src="spotifyArtist.images[2].url" class="tw-object-cover tw-rounded-full"></v-avatar>
              </inertia-link>

                <!-- Mobile menu button  -->

              <div class="tw-flex md:tw-hidden">
                <button v-on:click="showMenu()" type="button" class="tw-text-gray-100 hover:tw-text-gray-400 focus:tw-outline-none focus:tw-text-gray-400">
                  <svg v-if="showMobileMenu == false" viewBox="0 0 24 24" class="tw-text-gray-500 tw-w-6 tw-h-6 tw-fill-current">
                    <path fill-rule="evenodd" d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z"></path>
                  </svg>
                  <div v-else class="tw-text-gray-500 tw-w-6 tw-h-6 tw-fill-current">
                    <img src="/imgs/close.svg">
                  </div>
                </button>
              </div>   
            </div>

            <!-- Mobile Menu open: "block", Menu closed: "hidden" -->

            <div class="container-menu__responsive tw-w-full md:tw-flex tw-justify-end">
              <ul
                id="fit"
                :class="{'tw-flex md:tw-bg-transparent tw-text-black tw-p-2' : showMobileMenu, 'tw-hidden tw-p-2' : !showMobileMenu,  'bg_responsive' : !isScrolled}"
                class="tw-flex-col md:tw-ml-2 tw-mt-3 tw-space-y-4 tw-transition-400 tw-border-transparent tw-rounded md:tw-flex md:tw-space-y-0 md:tw-flex-row md:tw-items-center md:tw-space-x-10 md:tw-mt-0"
                v-if="loaded"
              >
                <li class="tw-text-sm tw-p-1 tw-cursor-pointer link tw-font-sans">
                  <inertia-link v-on:click="showMenu()" class="tw-font-sans" :class="{'color_gray': isScrolled, 'tw-text-white': !isScrolled}" :href="tenant ? `/` : `/artist/${artist.artista_url}/`">
                    HOME
                  </inertia-link>
                </li>
                <li class="tw-text-sm tw-p-1 tw-cursor-pointer link">
                  <inertia-link v-on:click="showMenu()" class="tw-font-sans" :class="{'color_gray': isScrolled, 'tw-text-white': !isScrolled}" :href="tenant ? `/schedule` : `/artist/${artist.artista_url}/schedule`">
                    {{selectedLanguage == 'US' ? en.title_2 : pt.title_2}}
                  </inertia-link>
                </li>
                <li class="tw-text-sm tw-p-1 tw-cursor-pointer link">
                  <inertia-link v-on:click="showMenu()" class="tw-font-sans" :class="{'color_gray': isScrolled, 'tw-text-white': !isScrolled}" :href="tenant ? `/singles` : `/artist/${artist.artista_url}/singles`">
                    {{selectedLanguage == 'US' ? en.title_3 : pt.title_3}}
                  </inertia-link>
                </li>
                <li class="tw-text-sm tw-p-1 tw-cursor-pointer link">
                  <inertia-link v-on:click="showMenu()" class="tw-font-sans" :class="{'color_gray': isScrolled, 'tw-text-white': !isScrolled}" :href="tenant ? `/albums` : `/artist/${artist.artista_url}/albums`">
                    {{selectedLanguage == 'US' ? en.title_3_1 : pt.title_3_1}}
                  </inertia-link>
                </li>
                <li class="tw-text-sm tw-p-1 tw-cursor-pointer link">
                  <inertia-link v-on:click="showMenu()" class="tw-font-sans" :class="{'color_gray': isScrolled, 'tw-text-white': !isScrolled}" :href="tenant ? `/playlists` : `/artist/${artist.artista_url}/playlists`">
                    {{selectedLanguage == 'US' ? en.title_4 : pt.title_4}}
                  </inertia-link>
                </li>
                <li class="tw-text-sm tw-p-1 tw-cursor-pointer link">
                  <inertia-link v-on:click="showMenu()" class="tw-font-sans" :class="{'color_gray': isScrolled, 'tw-text-white': !isScrolled}" :href="tenant ? `/contact` : `/artist/${artist.artista_url}/contact`" v-if="pageOptions && (pageOptions.email || pageOptions.contractor_email || pageOptions.contractor_phone)">
                    {{selectedLanguage == 'US' ? en.title_5 : pt.title_5}}
                  </inertia-link>
                </li>
                <li class="tw-text-sm tw-p-1 tw-cursor-pointer link">
                  <inertia-link v-on:click="showMenu()" class="tw-font-sans" :class="{'color_gray': isScrolled, 'tw-text-white': !isScrolled}" :href="tenant ? `/about` : `/artist/${artist.artista_url}/about`" v-if="pageOptions && (pageOptions.email || pageOptions.contractor_email || pageOptions.contractor_phone)">
                    {{selectedLanguage == 'US' ? en.title_6 : pt.title_6}}
                  </inertia-link>
                </li>
                <button type="button" @click.prevent="exclusiveLink()" v-if="loaded == true && artist.backstage ? artist.backstage.page_active == 1 : false" class="tw-text-xs tw-tracking-widest tw-mr-2 tw-hidden md:tw-block v-btn v-btn--is-elevated v-btn--has-bg theme--dark v-size--default"><span class="v-btn__content">{{selectedLanguage == 'US' ? en.bt : pt.bt}}</span></button>
              </ul>
              <!-- <ul> -->
              <!-- </ul> -->
            </div>
          </nav>
        </div>
      </div>
    </v-container>      

    <v-main>
          <slot />
    </v-main>

    <!-- Footer -->
    <app-footer :artist="artist" v-if="loaded"/>
  </v-app>
</template>

<script>

require('readmore-js');
import AppFooter from '@/Shared/Footer';
import EventBus from '@/eventbus';
import pt from "../lang/smartsite/layout_2/layout_2.js";

export default {
    mixins: [pt],
    components: {AppFooter},
    data() {
      return {
        showMobileMenu: false,
        artist: '',
        pageOptions: '',
        loaded: false,
        isScrolled: false,
        selectedLanguageObj: {},
      }
    },
    metaInfo() {
      return {
        title: ``,
      }
    },
    computed: {
      selectedLanguage() { 
        return this.$page.props.lang;
      }
    },
    methods: {
      switchLanguage(language){
        var local = document.location;
        axios.post("/switch-lang", {language: language})
        .then(() => local.reload())
      },
      showMenu(){
        this.showMobileMenu = !this.showMobileMenu;
      },
      exclusiveLink(){
        this.$inertia.visit(this.tenant ? '/backstage' : '/artist/'+this.artist.artista_url+'/backstage');
      },
    },
    created(){
      const vm = this;
      EventBus.$on('artist', function (artists) {
        vm.artist = artists.artist;
        vm.pageOptions = artists.pageOptions;
        vm.loaded = true
      });
    },
    mounted() {
      const vm = this;
      window.onscroll = function() {
        if(window.pageYOffset > 30) {
          vm.isScrolled = true;
        }
        else {
          vm.isScrolled = false;
        }
      }
      // vm.fadeIn();
    },
}
</script>


<style scoped>

.bg_nav {
  background: #2a2a2a;
}

.bg_sub_nav {
  background: #202020;
}

.color_gray{
  color: #D3D3D3 !important;
}

.bg_gray{
  background-color: #696969 !important;
}

.navbar {
  position: fixed;
  height: 60px;
  width: 100%;
}

.btn-default {
  border: none;
  background: transparent;
  outline: none;
}

.theme--dark.v-app-bar.v-toolbar.v-sheet {
  background: transparent;
}

#link_upnav {
  color: white;
}

.link {
  transition: 0.2s;
}

.link:hover {
  color: #BBB5A6;
  background: rgba(0, 0, 0, 2%);
  border-radius: 5px;
}

.bg_responsive {
  background: #2a2a2a;
}

/**** Fade 
* .transition {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 101;
  background-color: rgb(131, 124, 124, 0.5);
  opacity: 0;
  pointer-events: none;
  transition: 0.3s ease-in-out;
}

.transition.is-active {
  opacity: 1;
  pointer-events: all;
} 
*/

@media (min-width: 768px) {
  .bg_responsive {
    background: transparent;
  }
}

@media (min-width: 1024px) {
  .navbar {
    width: 100% !important;
  }
}

@media (min-width: 960px) {
  .default_width, .default_width__video {
    max-width: 100%;
  }
}

@media (min-width: 768px) {
  #fit {
    width: fit-content;
  }
}

</style>